import React, { useEffect, useState } from "react";
import Styles from "./style.module.css";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import {
    BasicInfo_Bank_info_ADD,
    GET_BasicInfo_Bank_info,
} from "Services/Requests";
import Load from "Components/Loader/loader";
import StepperComp from "Components/Stepper/StepperComp";
import {
    showSuccessNotification,
    showWarningNotification,
} from "Utils/Notifications";
import { useStore } from "Store";

import { showWarningAlert } from "Utils/Alerts";
interface Inputs {
    bank_name: "string";
    routing_number: string;
    bank_account_number: string;
    bank_account_type: string;
    name_of_the_account: string;
}
function BankInfo() {
    const [loading, setLoading] = useState(false);
    const { isDisabled } = useStore((state: any) => state);
    const [isChecked, setIschecked] = useState(false);
    const {
        register,
        handleSubmit,
        watch,
        setValue,
        control,
        reset,
        formState: { errors },
    } = useForm<Inputs>();
    const GetDetails = async () => {
        setLoading(true);
        try {
            const response = await GET_BasicInfo_Bank_info();
            setTimeout(() => {
                setLoading(false);
            }, 300);
            if (response.data.status == 1) {
                let data = response.data.bank_details;
                reset({
                    bank_name: data.bank_name,
                    routing_number: data.routing_number,
                    bank_account_number: data.bank_account_number,
                    bank_account_type: data.bank_account_type,
                    name_of_the_account: data.name_of_the_account,
                });
            } else {
                showWarningAlert(
                    "Something went wrong try again,if Issue persists Contact Support team"
                );
                setLoading(false);
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    useEffect(() => {
        GetDetails();
    }, []);
    const onSubmit: SubmitHandler<Inputs> = async (data) => {
        if (!isChecked) {
            return;
        }
        let body = [
            {
                Table: "bank_details",
                Data: {
                    bank_name: data.bank_name,
                    routing_number: data.routing_number,
                    bank_account_number: data.bank_account_number,
                    bank_account_type: data.bank_account_type,
                    name_of_the_account: data.name_of_the_account,
                },
            },
        ];
        setLoading(true);
        try {
            const response = await BasicInfo_Bank_info_ADD(body);
            setLoading(false);
            if (response.data.Status === 1) {
                showSuccessNotification("Personal info updated successfully");
            } else {
                showWarningAlert(
                    response?.data.Message || "Somethign went wrong try again"
                );
            }
        } catch (err: any) {
            showWarningAlert(
                "Something went wrong try again,if Issue persists Contact Support team"
            );
            setLoading(false);
        }
    };
    return (
        <>
            <div className={Styles["Container"]}>
                {loading && <Load />}

                <form action="" onSubmit={handleSubmit(onSubmit)}>
                    <div className={`${Styles["info"]} ${Styles["twoCols"]}`}>
                        <h3>
                            Bank Information for Direct Deposit <br />
                        </h3>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">Name of the account holder</label>
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Name of the account"
                                className={
                                    errors?.name_of_the_account &&
                                    Styles["error-input"]
                                }
                                {...register("name_of_the_account", {
                                    required: false,
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                            />
                            {errors?.name_of_the_account && (
                                <p>{errors?.name_of_the_account?.message} </p>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">Name of the bank</label>
                            <input
                                disabled={isDisabled}
                                type="text"
                                placeholder="Name of the bank"
                                className={
                                    errors?.bank_name && Styles["error-input"]
                                }
                                {...register("bank_name", {
                                    required: false,
                                    pattern: {
                                        value: /^[A-Za-z\s]*$/, // Allows alphabetic characters and spaces
                                        message:
                                            "Only alphabetic characters and spaces are allowed",
                                    },
                                })}
                            />
                            {errors?.bank_name && (
                                <p>{errors?.bank_name?.message} </p>
                            )}
                        </div>{" "}
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">
                                US bank Routing number (9 digits)
                            </label>
                            <Controller
                                disabled={isDisabled}
                                name="routing_number"
                                control={control}
                                rules={{
                                    required: "Routing number is required",
                                    pattern: {
                                        value: /^\d{9}$/, // Only allows exactly 9 digits
                                        message:
                                            "Router number must be exactly 9 digits",
                                    },
                                }}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        className={
                                            errors?.routing_number &&
                                            Styles["error-input"]
                                        }
                                        type="text" // Use type="text" to better control the value
                                        placeholder="US bank Routing number (9 digits)"
                                        maxLength={9} // Limit the input to 9 characters
                                        onInput={(e) => {
                                            // Cast the event target to HTMLInputElement to access value
                                            const input =
                                                e.target as HTMLInputElement;
                                            input.value = input.value.replace(
                                                /[^0-9]/g, // Replace non-numeric characters
                                                ""
                                            );
                                        }}
                                    />
                                )}
                            />
                            {errors?.routing_number && (
                                <p>{errors?.routing_number?.message}</p>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">US Bank Account Number</label>
                            <input
                                disabled={isDisabled}
                                className={
                                    errors?.bank_account_number &&
                                    Styles["error-input"]
                                }
                                type="number"
                                placeholder="US Bank Account Number"
                                {...register("bank_account_number", {
                                    required: false,
                                })}
                            />
                            {errors?.bank_account_number && (
                                <p>This is required </p>
                            )}
                        </div>
                        <div className={Styles["form-control"]}>
                            <label htmlFor="">Type of Account</label>
                            <select
                                disabled={isDisabled}
                                className={
                                    errors?.bank_account_type &&
                                    Styles["error-input"]
                                }
                                id=""
                                {...register("bank_account_type", {
                                    required: false,
                                })}>
                                <option value="">Please select</option>
                                <option value="checking_acc">
                                    Checking Account
                                </option>
                                <option value="saving_acc">
                                    Savings Account
                                </option>
                                <option value="others">Others</option>
                            </select>
                            {errors?.bank_account_type && (
                                <p>This is required </p>
                            )}
                        </div>
                        <div
                            className={Styles["declaration"]}
                            style={{ gridColumn: "1/-1" }}>
                            <h3>
                                <input
                                    disabled={isDisabled}
                                    type="checkbox"
                                    id="pushNotification"
                                    onChange={(e) =>
                                        setIschecked(e.target.checked)
                                    }
                                />
                                <label
                                    htmlFor="pushNotification"
                                    className={Styles["checkbox-label"]}>
                                    I declare that the information in this
                                    application is true and correct{" "}
                                </label>
                            </h3>
                            <div className={Styles["save-btns"]}>
                                <button disabled={isDisabled || !isChecked}>
                                    Save
                                </button>
                                {/* <button type="button">Reset</button> */}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}

export default BankInfo;
